module.exports = __webpack_public_path__ + "static/media/828CameronMadisonAlexanderBlvdNW_2018-07-09_140.5afa62a3.jpg";